module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.90d1676.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard/assest/font/roboto/Roboto-Medium.woff2
// module id = +5uO
// module chunks = 0